const $ = jQuery.noConflict();

const gridExpand = () => {
	// Cache DOM
	const $window = $(window);
	const body = $('html, body');
	const header = body.find('header.header');
	const gridItems = $('.grid-section__grid-item');
	const closeBtn = $('.grid-section__grid-item-close-btn');
	const gridItemClassExpanded = '.grid-section__grid-item--expanded';
	const gridItemClassNormal = '.grid-section__grid-item--normal';
	const gridItemClass = '.grid-section__grid-item';

	// Functions
	const setPosition = (item) => {
		const itemNormal = $(item).find(gridItemClassNormal);
		const itemExpanded = $(item).find(gridItemClassExpanded);
		const itemNormalHeight = itemNormal.outerHeight();
		const itemExpandedHeight = itemExpanded.outerHeight();

		if ($window.width() >= 768) {
			itemExpanded.css('top', `${itemNormalHeight + 50}px`);
			$(item).css('margin-bottom', `${itemExpandedHeight + 100}px`);
		} else {
			itemExpanded.css('top', `${-80}px`);
			$(item).css('margin-bottom', `${itemExpandedHeight - itemNormalHeight - 40}px`);
		}
	};

	const closeExpandedView = (e) => {
		const item = $(e.target).closest(gridItemClass);
		const itemExpanded = item.find(gridItemClassExpanded);

		gridItems.css('margin-bottom', '');
		itemExpanded.hide();

		if ($window.width() >= 768) {
			body.animate({
				scrollTop: item.offset().top - header.height() - parseInt(item.css('margin-top'), 10) - 30,
			}, 600);
		} else {
			body.animate({
				scrollTop: item.offset().top - header.height() - parseInt(item.css('margin-top'), 10) - 40,
			}, 600);
		}
	};

	const showExpandedView = (e) => {
		const item = $(e.target).closest(gridItemClass);
		const itemExpanded = item.find(gridItemClassExpanded);

		gridItems.css('margin-bottom', '');

		if (!itemExpanded.is(':visible')) {
			gridItems.find(gridItemClassExpanded).hide();
			setPosition(item);
			itemExpanded.fadeIn(600);

			if ($window.width() >= 768) {
				body.animate({
					scrollTop: itemExpanded.offset().top - header.height() - 40,
				}, 600);
			} else {
				body.animate({
					scrollTop: item.offset().top - header.height() - parseInt(item.css('margin-top'), 10) - 40,
				}, 600);
			}
		} else {
			itemExpanded.hide();

			if ($window.width() >= 768) {
				body.animate({
					scrollTop: item.offset().top - header.height() - parseInt(item.css('margin-top'), 10) - 30,
				}, 600);
			} else {
				body.animate({
					scrollTop: item.offset().top - header.height() - parseInt(item.css('margin-top'), 10) - 40,
				}, 600);
			}
		}
	};

	const recalculateItemPosition = () => {
		gridItems.each((i, item) => {
			if ($(item).find(gridItemClassExpanded).is(':visible')) {
				setPosition(item);
			}
		});
	};

	// Bind Events
	if (gridItems.length) {
		gridItems.find(gridItemClassNormal).on('click', showExpandedView);
		closeBtn.on('click', closeExpandedView);
		$window.on('resize', recalculateItemPosition);
	}
};

export default gridExpand;
